<template>
  <!--  图集新闻-->
  <div class="atlas-news" @click="hideInput">
    <img src="https://img.qiluyidian.net/shareimg20191216.jpg" alt="" style="z-index: -10;position: absolute">
    <div class="tips clearfix" ref="tips">
      <span class="homeIcon" :style="{backgroundImage:home_url,backgroundSize:'100%'}" @click.stop="goHome"></span>
      <i class="rightLine"></i>
      <span class="slogon">齐鲁晚报官方APP</span>
      <span class="openApp" @click.stop="down">打开</span>
    </div>
    <div class="loading" :style="{backgroundImage:loading_url,backgroundSize:'20%'}" v-if="loading==0"></div>
    <div class="loading" :style="{backgroundImage:error2_url,backgroundSize:'50%'}" v-else-if="loading==1"></div>
    <div class="loading" :style="{backgroundImage:deleted_url,backgroundSize:'50%'}" v-else-if="loading==2"></div>
    <div class="infoWrapper">
      <p class="newsTitle">{{infoDetails.title}}</p>

      <div class="newsAuthor clearfix">
        <div class="sourceTime">
          <span class="source" v-if="infoDetails.source">{{infoDetails.source}}</span>
          <span class="time">{{infoDetails.publishtime}}</span>
        </div>
      </div>
      <!--      新闻内容-->
      <div class="news" id="img_box">
        <p ref="content" class="content" v-for="(item,index) in infoDetails.imglist">
          <img v-if="item.url" :src="item.url + param" alt="">
          <img v-else src="../../common/img/defaultPicture.png" alt="">{{item.content}}
        </p>
      </div>
      <!--      记者列表-->
      <div class="repoterList" v-if="infoDetails.relate_reporter">
        <div class="repoter clearfix" v-for="(item,index) in infoDetails.relate_reporter">
          <div class="imgV" @click.stop="sendShow('1',infoDetails.newsId,item.reporter_id)">
            <img v-if="item.head_img" class="headImg" :src="item.head_img" alt="">
            <img v-else class="headImg" src="../../common/img/headImg.png" alt="">
            <img class="headV" :src="redV" alt="">
          </div>
          <div class="nameAdress">
            <p class="name">{{item.reporter_name}}</p>
            <p class="adress">{{item.signature}}</p>
          </div>
          <span class="quest"
                @click.stop="getRetName(item.reporter_name);sendShow('1',infoDetails.newsId,item.reporter_id)">爆料</span>
        </div>
      </div>
    </div>
    <!--    热门资讯-->
    <div class="hotNews" v-if="infoDetails.sourceInfoList">
      <p class="listName"><span>热门资讯</span></p>
      <div class="newType" v-for="(item,index) in infoDetails.sourceInfoList">
        <!--        广告  isAd  1-->
        <div class="newListAdv" @click.stop="goMost(item.isAd,item.conentid,item.detailurl,item.status)"
             v-if="item.isAd == '1'">
          <p class="advTitle">{{item.conenttitle}}</p>
          <img v-if="item.conentimg1" class="advImg" :src="item.conentimg1 + param" alt="">
          <img v-else class="advImg" src="../../common/img/defaultPicture.png" alt="">
          <p class="advText adColor1 clearfix">广告</p>
        </div>
        <!--      普通新闻-->
        <div class="newList clearfix" v-else-if="item.conenttype == '1' || item.conenttype == '20'" @click.stop="goGeneral(item.conentid)">
          <img v-if="item.conentimg1" class="newImg" :src="item.conentimg1 + param" alt="">
          <img v-else class="newImg" src="../../common/img/defaultPicture.png" alt="">
          <img v-if="item.conenttype == '20'" class="ypTips" src="../../common/img/ypTips.png" alt="">
          <div class="newsRight">
            <p class="newsTitle">{{item.conenttitle}}</p>
            <p class="timeView">
              <span class="source read" v-if="item.channel_name">{{item.channel_name}}</span>
              <span class="source read" v-else-if="item.columnName">{{item.columnName}}</span>
              <span class="source" v-else>{{item.source}}</span>
              <span class="yue"
                    v-if="item.viewcount != 0&& item.viewcount != ''&&item.viewcount>=1000 || item.viewcount.indexOf('万')!='-1'">{{item.viewcount}}阅</span>
              <span class="ping"
                    v-if="item.commentcount != 0&& item.commentcount != ''&&item.viewcount<1000 && item.viewcount.indexOf('万')=='-1'">{{item.commentcount}}评</span>
              <span class="yue" v-else-if="item.timestr && (item.commentcount == 0 || item.commentcount =='')&&item.viewcount<1000 && item.viewcount.indexOf('万')=='-1'">{{item.timestr}}</span>
            </p>
          </div>
        </div>
        <!--       活动6  直播10（预告  回顾 未定） 商品5  图文直播8-->
        <div class="newListAdv" @click.stop="goLive(item.conentid)"
             v-else-if="item.conenttype == '10'">
          <p class="advTitle">{{item.conenttitle}}</p>
          <img v-if="item.conentimg1" class="advImg" :src="item.conentimg1 + param" alt="">
          <img v-else class="advImg" src="../../common/img/defaultPicture.png" alt="">
          <!--          <p class="advText adColor0">广告</p>-->
          <p class="advText adColor1" v-if="item.conenttype == '6'">活动</p>
          <p class="advText adColor1" v-else-if="item.conenttype == '5'">商品</p>
          <p class="advText adColor1" v-else-if="item.conenttype == '8'">图文直播</p>
          <p class="advText adColor1" v-else-if="item.conenttype == '10' && item.status == '1'">直播</p>
          <p class="advText adColor2" v-else-if="item.conenttype == '10' && item.status == '2'">预告</p>
          <p class="advText adColor0" v-else>回顾</p>
        </div>
        <!--       活动6  直播10（预告  回顾 未定） 商品5  图文直播8-->
        <div class="newListAdv" @click.stop="goMost(item.type,item.sourceId,item.detailurl,item.status)"
             v-else-if="item.conenttype == '10' || item.conenttype == '6' || item.conenttype == '5' || item.conenttype == '8'">
          <p class="advTitle">{{item.conenttitle}}</p>
          <img v-if="item.conentimg1" class="advImg" :src="item.conentimg1 + param" alt="">
          <img v-else class="advImg" src="../../common/img/defaultPicture.png" alt="">
          <!--          <p class="advText adColor0">广告</p>-->
          <p class="advText adColor1" v-if="item.conenttype == '6'">活动</p>
          <p class="advText adColor1" v-else-if="item.conenttype == '5'">商品</p>
          <p class="advText adColor1" v-else-if="item.conenttype == '8'">图文直播</p>
          <p class="advText adColor1" v-else-if="item.conenttype == '10' && item.status == '1'">直播</p>
          <p class="advText adColor2" v-else-if="item.conenttype == '10' && item.status == '2'">预告</p>
          <p class="advText adColor0" v-else>回顾</p>
        </div>
        <!--      视频-->
        <div class="newListVideo" @click.stop="goVideo(item.conentid)" v-else-if="item.conenttype == '3'">
          <p class="videoTitle">{{item.conenttitle}}</p>
          <div class="videoWraper">
            <img v-if="item.conentimg1" class="videoImg" :src="item.conentimg1 + param" alt="">
            <img v-else class="videoImg" src="../../common/img/defaultPicture.png" alt="">
            <span class="stop" :style="{backgroundImage:stop_url,backgroundSize:'13%'}"></span>
            <!--            <span class="time">{{item.time}}</span>-->
          </div>
          <p class="videoDetail">
            <span class="videoText" v-if="item.columnName">{{item.columnName}}</span>
            <span class="videoText" v-else="item.source">{{item.source}}</span>
            <span>{{item.timestr}}</span>
          </p>
        </div>
        <!--      图集新闻-->
        <div class="newListPic" @click.stop="goAtlas(item.conentid)" v-else-if="item.conenttype == '2'">
          <p class="picTitle">{{item.conenttitle}}</p>
          <div class="picWraper">
            <img class="picImg" v-if="item.conentimg1" :src="item.conentimg1 + param" alt="">
            <img class="picImg" v-else="!item.conentimg1" src="../../common/img/defaultPicture.png" alt="">
            <img class="picImg" v-if="item.conentimg2" :src="item.conentimg2 + param" alt="">
            <img class="picImg" v-else="!item.conentimg2" src="../../common/img/defaultPicture.png" alt="">
            <img class="picImg" v-if="item.conentimg3" :src="item.conentimg3 + param" alt="">
            <img class="picImg" v-else="!item.conentimg3" src="../../common/img/defaultPicture.png" alt="">
          </div>
        </div>
        <div class="thematicPic" @click.stop="goThematic(item.conentid)"
             v-else-if="item.conenttype == '4' && item.subjectNewsList.length > 0">
          <!--    专题-->
          <div id="thematic-news" class="thematic-news" v-if="item.subjectNewsList.length > 0">
            <div class="inner">
              <div class="title clearfix"><span class="thematic">专题</span><span class="thematicTitle">{{item.conenttitle}}</span><span
                class="more clearfix"
              >更多<i class="moreIcon" :style="{backgroundImage:more,backgroundSize:'contain'}"></i></span></div>
              <div class="content">
                <swiper :options="swiperOptionThematic">
                  <swiper-slide v-for="(sub,index) in item.subjectNewsList" :key="index" class="slideItem">
                    <!--       图片-->
                    <div class="wrap" @click="goThematic(item.conentid)">
                      <div class="videoTop">
                        <img v-if="sub.conentimg1" :src="sub.conentimg1 + param" alt="">
                        <img v-else src="../../common/img/defaultPicture.png" alt="">
                      </div>
                      <div class="bottom">
                        <div class="radar-title" v-html="sub.conenttitle"></div>
                        <div class="info">
                          <span class="name">{{sub.timestr}}</span>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </div>
        </div>
        <i class="line" v-if="index < infoDetails.sourceInfoList.length"></i>
      </div>
      <!--    单独广告图片-->
      <div class="advPic" v-if="infoDetails.adinfo" @click.stop="goAdv(infoDetails.adinfo.detailurl)">
        <img v-if="infoDetails.adinfo.conentimg1" :src="infoDetails.adinfo.conentimg1" alt="">
        <img v-else src="../../common/img/defaultPicture.png" alt="">
      </div>
    </div>
    <!--    评论-->
    <div class="commentWraper" ref="comment" id="comment">
      <p class="commentTitle" v-if="infoDetails.commentcount>0">精彩评论({{infoDetails.commentcount}})</p>
      <p class="commentTitle" v-else>精彩评论</p>
      <div class="commentList" v-for="(item,index) in commentList">
        <div class="commentInfo clearfix">
          <div class="headImg">
            <img v-if="item.head_img" :src="item.head_img" alt="">
            <img v-else src="../../common/img/headImg.png" alt="">
            <span class="v" :style="{backgroundImage:v_url,backgroundSize:'contain'}"
                  v-if="item.user_name_status == 2"></span>
            <span class="v" :style="{backgroundImage:v1_url,backgroundSize:'contain'}"
                  v-if="item.user_name_status == 1"></span>
          </div>
          <div class="person">
            <p class="name v_name commonName">
              {{item.user_name}}</p>
            <!--            <p class="name v_name" :class="{commonName:item.user_name_status !=1 && item.user_name_status !=2}">-->
            <!--              {{item.user_name}}</p>-->
            <!--            <p class="job" v-if="item.company && (item.user_name_status ==1 && item.user_name_status ==2)">-->
            <!--              {{item.company}}</p>-->
          </div>
          <div class="good clearfix">
            <span class="goodNo" v-if="item.is_praise==0 && item.praise_sum >0">{{item.praise_sum}}</span>
            <span class="goodNo" v-else-if="item.praise_sum >0" style="color: #E51C23">{{item.praise_sum}}</span>
            <span class="goodIcon" @click.stop="snap(item.inner_id,index)"
                  :style="{backgroundImage:good_url,backgroundSize:'contain'}"
                  v-if="item.is_praise==0"></span>
            <span class="goodIcon"
                  :style="{backgroundImage:good_has_url,backgroundSize:'contain'}" v-else @click.stop="hasSnap"></span>
          </div>
        </div>
        <div class="commentText" @click.stop="sendShow('',infoDetails.newsId,'',item.inner_id)"
             v-html="processComment(item.content)"></div>
        <div class="commentTimeReply">
          <span class="commentTime">{{item.sub_time}}</span>
          <span class="commentReply"
                @click.stop="getReplyName(item.user_name);sendShow('',infoDetails.newsId,'',item.inner_id)">回复</span>
          <span class="delPreply" @click.stop="delRply(item.inner_id)" v-if="item.is_opt == 1">删除</span>
        </div>
        <div class="commentOthers" v-if="item.children.length > 0">
          <p class="others" v-for="com in item.children"><span class="otherName">{{com.user_name}}：</span><span
            v-html="processComment(com.content)"></span>
          </p>
        </div>
        <i class="line" v-if="index < commentList.length-1"></i>
      </div>
      <div v-if="!commentList" class="noComment"><img src="../../common/img/noComment.png" alt=""></div>
    </div>
    <div class="appGoWrapper" @click.stop="down" v-if="commentMore">
      <p class="openAppGo">打开壹点APP，查看更多评论</p>
    </div>
    <div class="appGoWrapper1" v-else></div>
    <!--    评论框-->
    <div class="commentInput clearfix" v-if="inputStatus">
      <span class="index1" :style="{backgroundImage:index1_url,backgroundSize:'contain'}" @click.stop="goHome"></span>
      <p class="inputFalse" @click.stop="sendShow('0',infoDetails.newsId,'','')">写评论…</p>
      <!--      <input placeholder="写评论…" @click.stop="sendShow('0',infoDetails.newsId,'','')"></input>-->
      <span class="commentNo" :style="{backgroundImage:comment_url,backgroundSize:'contain'}"
            @click.stop="goComment(infoDetails.newsId)">
<!--              <span v-if="!infoDetails.commentcount || infoDetails.commentcount==0">0</span>-->
        <span v-if="infoDetails.commentcount >999">999+</span>
        <span v-else-if="infoDetails.commentcount>0">{{infoDetails.commentcount}}</span>
      </span>
      <span class="hotSearch" :style="{backgroundImage:hotSearch_url,backgroundSize:'100%'}"
            @click.stop="goHotSearch">
      <span v-if="hotNo >0 && hotNo < 101">{{hotNo}}</span>
      </span>
    </div>
    <div class="commentInput0 clearfix" v-else>
      <form @submit.prevent="formSubmit" action="javascript:return true">
        <input type="text" v-model="comment" ref="inputComtent" :placeholder="dateinit" @click.stop="emojiShow = false"
               @keyup.enter="reply()"
               @input="addColor" v-focus="true"></input>
      </form>
      <div class="sendEmoji clearfix">
       <span class="smile" :style="{backgroundImage:smile_url,backgroundSize:'contain'}"
             @click.stop="emoji"></span>
        <span class="send" ref="send" @click.stop="reply();inputStatus = true">发送</span>
      </div>
      <div class="emojiBlock" v-if="emojiShow">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(slide, index) in swiperSlides" :key="index" style="padding: 15px 0 30px">
            <img @click.stop="senEmoji(item.Tag)" v-for="item in slide" :src="item.File" alt="" :id="item.ID"
                 :tag="item.Tag">
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!--    图片放大-->
    <div class="enlargePicture" v-if="imgPreviewBlock" @click.stop="imgPreviewBlock = false">
      <swiper :options="swiperOptionImg" ref="swiper">
        <swiper-slide v-for="(img, index) in imgArr" :key="index" style="padding: 15px 0 30px">
          <div class="pinch-zoom" style="width: 100%;height: 100%">
            <img v-if="img" class="previewImg" :src="img" alt="">
            <img v-else class="previewImg" src="../../common/img/defaultPicture.png" alt="">
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="toTop" v-if="topShow">
<!--      <span class="top" :style="{backgroundImage:collect_url,backgroundSize:'contain'}" @click.stop="toTop"></span>-->
<!--      <span class="index" :style="{backgroundImage:index_url,backgroundSize:'contain'}" @click.stop="goHome"></span>-->
      <span class="collectNo" :style="{backgroundImage:collect1_url,backgroundSize:'contain'}" v-if="praiseStatus"
            @click.stop="collect(infoDetails.newsId)">
<!--        <span v-if="infoDetails.praisecount == ''">0</span>-->
        <span v-if="infoDetails.praisecount >999">999+</span>
        <span v-else-if="infoDetails.praisecount>0">{{infoDetails.praisecount}}</span>
      </span>
      <span class="collectNo" :style="{backgroundImage:collect1_url,backgroundSize:'contain'}" v-else
            @click.stop="collect(infoDetails.newsId)">
          <span v-if="infoDetails.praisecount >999">999+</span>
        <span v-else-if="infoDetails.praisecount>0">{{ infoDetails.praisecount}}</span>
      </span>
    </div>
  </div>
</template>

<script>
    import '../../common/css/reset1.css'
    import {getUrlParam, startMover, confirm, scriptFun, configData} from "../../common/js/common";
    import {login, WXauthorize, getCookie, isWeixin} from "../../common/js/authorize";
    import {swiper, swiperSlide} from 'vue-awesome-swiper'
    import emojiJson from '../../common/js/emoji-config-list'
    import config from '../../common/js/config'
    import {getWeixinAuth} from "../../common/js/weixinshare";
    import {previewImg} from "../../common/js/preview";
    import {
        atlasDetails,
        newsCommentList,
        newsAddComment,
        newsSnap,
        newsContentSnap,
        newsContentSnapCancle,
        newsCommentReply,
        newsCommentDel,
        getActUrl,
        hotNum,
    } from "../../common/api/api";

    export default {
        name: 'atlas-news',
        components: {
            swiper,
            swiperSlide
        },
        data() {
            return {
                param:'?imageView2/2/w/720/q/85|imageslim',
                comment: '',
                home_url: "url(" + require('../../common/img/home.png') + ")",
                head_url: "url(" + require('../../common/img/headImg.png') + ")",
                good_url: "url(" + require('../../common/img/zan.png') + ")",
                good_has_url: "url(" + require('../../common/img/zan_has.png') + ")",
                v_url: "url(" + require('../../common/img/redV.png') + ")",
                v1_url: "url(" + require('../../common/img/blueV.png') + ")",
                redV: '../../common/img/redV.png',
                blueV: '../../common/img/blueV.png',
                smile_url: "url(" + require('../../common/img/smile.png') + ")",
                comment_url: "url(" + require('../../common/img/comment.png') + ")",
                collect1_url: "url(" + require('../../common/img/collect1.png') + ")",
                collect_url: "url(" + require('../../common/img/collect.png') + ")",
                collect_has_url: "url(" + require('../../common/img/collect_has.png') + ")",
                loading_url: "url(" + require('../../common/img/loading.gif') + ")",
                error_url: "url(" + require('../../common/img/newsError.png') + ")",
                error1_url: "url(" + require('../../common/img/newsError1.png') + ")",
                deleted_url: "url(" + require('../../common/img/newsDelete.png') + ")",
                stop_url: "url(" + require('../../common/img/video-stop.png') + ")",
                more: "url(" + require('../../common/img/more.png') + ")",
                top_url: "url(" + require('../../common/img/comment.png') + ")",
                index_url: "url(" + require('../../common/img/index.png') + ")",
                index1_url: "url(" + require('../../common/img/index1.png') + ")",
                hotSearch_url: "url(" + require('../../common/img/hotSear.png') + ")",
                tags: [],
                infoDetails: [],
                commentList: '',//评论列表
                inputStatus: true,
                city: [
                    {label: '济南市', value: 135},
                    {label: '青岛市', value: 136},
                    {label: '淄博市', value: 137},
                    {label: '枣庄市', value: 138},
                    {label: '东营市', value: 139},
                    {label: '烟台市', value: 140},
                    {label: '潍坊市', value: 141},
                    {label: '济宁市', value: 142},
                    {label: '泰安市', value: 143},
                    {label: '威海市', value: 144},
                    {label: '日照市', value: 145},
                    {label: '莱芜市', value: 146},
                    {label: '临沂市', value: 147},
                    {label: '德州市', value: 148},
                    {label: '聊城市', value: 149},
                    {label: '滨州市', value: 150},
                    {label: '菏泽市', value: 151},
                ],
                cityId: '',
                newsId: '',
                swiperOptionThematic: {
                    // loop : true,
                    slidesPerView: 2,
                    freeMode: true,
                    freeModeMomentum: false,
                },
                swiperOption: {
                    pagination: {
                        el: '.swiper-pagination'
                    }
                },
                swiperSlides: [],
                swiperOptionImg: {
                    initialSlide: 0,
                    pagination: {
                        el: '.swiper-pagination'
                    }
                },
                emojiShow: false,
                reply_type: '',
                rId: '',
                commentId: '',
                imgArr: [],
                contentImg: [],
                imgPreviewBlock: false,
                praiseStatus: true,
                dateinit: '写评论…',
                repName: '',
                replyName: '',
                routeId: '',
                // token:'7BB04144312EF0BC6CEE12E70539BE4B',
                token: '',
                isLogin: false,
                loading: 0,
                arrayH: [],
                commentMore: false,
                topShow:false,
                hotNo:'',
            }
        },
        watch: {},
        directives: {
            focus: {
                inserted: function (el, {value}) {
                    console.log(el, {value})
                    if (value) {
                        el.focus();
                    }
                }
            }
        },
        mounted() {
            this.$nextTick(function () {
                scriptFun();
                if (!isWeixin()) {
                    this.$refs.tips.style.display = 'none';
                    document.getElementsByClassName('commentInput')[0].style.display = 'none';
                    document.getElementsByClassName('commentInput0')[0].style.display = 'none';
                }
                // getWeixinAuth();
                login();
                if (getCookie('token') != '' && getCookie('token') != null) {
                    this.token = getCookie('token');
                    this.isLogin = true;
                } else {
                    this.isLogin = false;
                }
                for (let i = 0; i < emojiJson.length; i++) {
                    for (let j = 0; j < emojiJson[i].length; j++) {
                        emojiJson[i][j].File = config.wsStatisUrl + '/web/lib/img/emoji/' + emojiJson[i][j].File;
                    }
                    this.swiperSlides.push(emojiJson[i])
                }
                ;
            })
        },
        created() {
            this.routeId = getUrlParam('id');
            this.getHotNum();
            this.fetchDetails();
            this.fetchComment();
            window.addEventListener('scroll', () => {
                var u = navigator.userAgent;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                if (isAndroid) {
                    this.hideInput();
                }
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop; //滚动条距离顶部高度
                let clientHeight = document.documentElement.clientHeight;//屏高
                // 滚动两屏以上时显示返回顶部按钮
                let twoClient = clientHeight * 2;
                // if (scrollTop >= twoClient) {
                //     this.topShow = true;
                // } else {
                //     this.topShow = false;
                // }
                if (isWeixin()) {
                    let tips = document.getElementsByClassName('tips');
                    let toTop = document.getElementsByClassName('toTop');
                    this.arrayH.unshift(scrollTop);
                    this.arrayH.length = 2;
                    if (this.arrayH[0] > this.arrayH[1]) {//上滑
                        if (scrollTop <= 0) {
                            tips[0].style.display = 'block';
                            toTop[0].style.right = '15px';
                            toTop[0].style.opacity = '1';
                            toTop[0].style.transition = 'transform .1s,opacity .5s,right .5s';
                            toTop[0].style.transform = 'scale(1)';
                        } else {
                            tips[0].style.display = 'none';
                            toTop[0].style.right = '-25px';
                            toTop[0].style.opacity = '0.6';
                            toTop[0].style.transition = 'transform .1s,opacity .5s,right .5s';
                            toTop[0].style.transform = 'scale(1)';
                        }
                    } else if (this.arrayH[0] < this.arrayH[1] || scrollTop <= 0) {//下滑
                        tips[0].style.display = 'block';
                        toTop[0].style.right = '15px';
                        toTop[0].style.opacity = '1';
                        toTop[0].style.transition = 'transform .1s,opacity .5s,right .5s';
                        toTop[0].style.transform = 'scale(1)';
                    }
                }
            })
        },
        methods: {
            getHotNum(){
                let params = {
                    "newsId": this.routeId,
                    "token": ''
                };
                hotNum(params).then(res => {
                    if (res.data.rc == 0) {
                        this.hotNo = res.data.data;
                    }
                })
            },
            // 情报详情
            fetchDetails() {
                this.tags = [];
                if (getCookie('token') != '' && getCookie('token') != null) {
                    this.token = getCookie('token');
                } else {
                    this.token = '';
                }
                let params = {
                    "newsid": this.routeId,
                    "token": this.token
                };
                atlasDetails(params).then(res => {
                    if (res.data.rc == 0) {
                        this.loading = -1;
                        this.topShow = true;
                        this.infoDetails = res.data.data;
                        document.title = this.infoDetails.title;
                        getWeixinAuth();
                        this.$nextTick(function () {
                            for (let i = 0; i < this.infoDetails.imglist.length; i++) {
                                this.imgArr.push(this.infoDetails.imglist[i].url);
                            }
                            previewImg();
                            if (!isWeixin()) {
                                document.getElementsByClassName('infoWrapper')[0].style.paddingTop = 0;
                            }
                        });
                    }else if (res.data.rc == '301') {
                        this.loading = 2;
                    } else {
                        this.loading = 1
                    }
                })
            },
            // 图片放大
            imgPreview(index) {
                this.imgPreviewBlock = true;
                this.swiperOptionImg.initialSlide = index;
                this.$nextTick(function () {
                    let previewImgArr = document.getElementsByClassName('previewImg');
                    $(function () {
                        // console.log($('.pinch-zoom img').length)
                        $('.pinch-zoom img').each(function () {
                            // console.log($(this))
                            new RTP.PinchZoom($(this), {});
                        })
                    });
                    for (let j = 0; j < previewImgArr.length; j++) {
                        let eH = previewImgArr[j].naturalHeight;
                        let eW = previewImgArr[j].naturalWidth;
                        let proportion = eW / eH;
                        let sH = window.screen.availHeight;
                        let sW = window.screen.availWidth;
                        let eProportion = sW / sH;
                        if (eProportion > proportion) {
                            previewImgArr[j].style.height = sH - 20 + 'px';
                            previewImgArr[j].style.paddingTop = 10 + 'px';
                            let afterW = proportion * parseInt(previewImgArr[j].style.height.split('p')[0]);
                            previewImgArr[j].style.paddingLeft = (sW - afterW) / 2 + 'px';
                        } else {
                            previewImgArr[j].style.width = '100%';
                            let afterH = sW / proportion;
                            previewImgArr[j].style.paddingTop = (sH - afterH) / 2 + 'px';
                            previewImgArr[j].style.paddingLeft = 0;
                        }
                    }
                })
            },
            //评论
            fetchComment() {
                if (getCookie('token') != '' && getCookie('token') != null) {
                    this.token = getCookie('token');
                } else {
                    this.token = '';
                }
                let params = {
                    "newsid": this.routeId,//"1253674",
                    "pageno": "1",
                    "pagesize": "15",
                    "token": this.token
                };
                newsCommentList(params).then(res => {
                    if (res.data.rc == 0) {
                        this.commentList = res.data.data.commentlist;
                        if (this.commentList.length >= 5) {
                            this.commentList.length = 5;
                            this.commentMore = true;
                        } else {
                            this.commentList = res.data.data.commentlist;
                            this.commentMore = false;
                        }
                    }
                })
            },
            // 评论点赞
            snap(val, index) {
                if (this.isLogin) {
                    let params = {
                        "newscommentid": val,
                        "token": this.token
                    };
                    newsContentSnap(params).then(res => {
                        if (res.data.rc == 0) {
                            this.commentList[index].praise_sum++;
                            this.commentList[index].is_praise = 1
                            // this.fetchComment();
                        } else if (res.data.rc == -1) {
                            this.$toast.center('已点赞');
                        }
                    })
                } else {
                    WXauthorize()
                }
            },
            hasSnap() {
                this.$toast.center('已点赞');
            },
            emoji() {
                this.emojiShow = !this.emojiShow;
                this.$refs.inputComtent.blur();
            },
            senEmoji(val) {
                // this.$refs.textarea.blur();
                this.comment += val;
            },
            processComment(text) {
                for (let i = 0; i < emojiJson.length; i++) {
                    for (let j = 0; j < emojiJson[i].length; j++) {
                        for (let n = 0; n < text.length; n++) {
                            if (text.indexOf(emojiJson[i][j].Tag) != -1) {
                                let imgStr = '<img style="vertical-align: middle;width: 22px" src="' + emojiJson[i][j].File + '" alt="">';
                                text = text.replace(emojiJson[i][j].Tag, imgStr);
                            }
                        }
                    }
                }
                return text;
            },
            // 评论定位
            goComment(newsId) {
                let offTop = this.$refs.comment.offsetTop;
                document.documentElement.scrollTop = offTop - 60;
                document.body.scrollTop = offTop - 60;
            },
            //新闻点赞
            collect(newsId) {
                if (this.isLogin) {
                    let params = {
                        "token": this.token,
                        "newsid": this.routeId
                    };
                    newsSnap(params).then(res => {
                        if (res.data.rc == 0) {
                            this.praiseStatus = false;
                            this.praiseCount = res.data.data.praiseCount;
                            if (res.data.data.praiseDec == '-1') {
                                this.$toast.center('点赞已满');
                                // this.praiseStatus = false;
                            } else {
                                // startMover();
                                this.infoDetails.praisecount++
                                // this.fetchDetails();
                                // this.praiseStatus = true;
                            }
                        } else {
                            // this.$toast.center('点赞已满');
                        }
                    })
                } else {
                    WXauthorize();
                }

            },
            // 获取记者名字
            getRetName(name) {
                this.repName = name;
                this.dateinit = '';
            },
            //获取被评论人名字
            getReplyName(name) {
                this.replyName = name;
                this.dateinit = '';
            },
            // 评论回复
            sendShow(type, newsId, rId, cId) {
                if (this.isLogin) {
                    // token newsid新闻ID content评论内容  reply_typereply_type:1表示提问记者，0表示直接回复  to_userid被评论人id
                    this.inputStatus = false;
                    if (type == '1') {
                        this.reply_type = 1;
                        this.dateinit = '@' + this.repName;
                    } else if (type == '0') {
                        this.reply_type = 0;
                        this.dateinit = '写评论…';
                    } else {
                        this.dateinit = '回复' + this.replyName;
                    }
                    this.newsId = this.routeId;
                    this.commentId = cId;
                    this.rId = rId;
                    this.$refs.inputComtent.focus();
                    this.emojiShow = false;
                } else {
                    WXauthorize();
                }
            },
            reply() {
                if (this.commentId) {
                    //token newsid新闻ID  comment_id评论id  content回复内容
                    let params = {
                        "newsid": this.newsId,//"1253674",
                        "content": this.comment,
                        "comment_id": this.commentId,
                        "token": this.token
                    };
                    if (this.newsId != '') {
                        params.newsid = this.newsId;
                    }
                    newsCommentReply(params).then(res => {
                        if (res.data.rc == 0) {
                            this.$toast.center('发布成功！');
                            this.comment = '';
                            this.fetchComment();
                            this.goComment(this.newsId);
                        }
                    })
                } else {
                    // token newsid新闻ID content评论内容  reply_typereply_type:1表示提问记者，0表示直接回复  to_userid被评论人id
                    let params = {
                        "newsid": this.routeId,//"1253674",
                        "content": this.comment,
                        "reply_type": this.reply_type,
                        "to_userid": this.rId,
                        "token": this.token
                    };
                    newsAddComment(params).then(res => {
                        if (res.data.rc == 0) {
                            this.$toast.center('发布成功！');
                            this.comment = '';
                            this.fetchComment();
                            this.goComment(this.newsId);
                        }
                    })
                }
            },
            // 删除评论
            delRply(cId) {
                if (this.isLogin) {
                    let mesg = confirm('确认删除评论？');
                    if (mesg == true) {
                        let params = {
                            "comment_id": cId,
                            "token": this.token
                        };
                        newsCommentDel(params).then(res => {
                            if (res.data.rc == 0) {
                                this.fetchComment();
                            }
                        })
                    }
                } else {
                    WXauthorize();
                }

            },
            // 热门资讯跳转
            goAtlas(id) {
                if(getUrlParam('from')){
                    location.href = configData.jumpUrl + '/atlas.html?id=' + id + '&mwb=' + 'mobi';
                }else {
                    location.href = configData.jumpUrl + '/atlas.html?id=' + id;
                }
            },
            goGeneral(id) {
                if(getUrlParam('from')){
                    location.href = configData.jumpUrl + '/general.html?id=' + id + '&mwb=' + 'mobi';
                }else {
                    location.href = configData.jumpUrl + '/general.html?id=' + id;
                }
            },

            goMost(type, id, url, status) {
                //活动 this.infoDetails.adinfo.type == '6'
                if (type == 6) {
                    let params = {
                        "active_id": id,
                    };
                    getActUrl(params).then(res => {
                        if (res.data.rc == 0) {
                            if (!res.data.data.small_id) {
                                window.location.href = res.data.data.html_id;
                            }
                        } else {
                        }
                    })
                }else if(type == 18){//情报 this.infoDetails.adinfo.type == '18'
                    if (getUrlParam('mwb')) {
                        location.href = configData.jumpUrl + '/info.html?id=' + id + '&mwb=' + 'mobi';
                    } else {
                        location.href = configData.jumpUrl + '/info.html?id=' + id;
                    }
                }else if (type == 12) {//外链
                    window.location.href = url;
                } else if (type == 1 || type == 20) {
                    this.goGeneral(id);
                } else if (type == 4) {
                    this.goThematic(id);
                } else if (type == 2) {
                    this.goAtlas(id);
                } else if (type == 10) {
                    if (getUrlParam('mwb')) {
                        location.href = configData.jumpUrl + '/live.html?id=' + id + '&mwb=' + 'mobi';
                    } else {
                        location.href = configData.jumpUrl + '/live.html?id=' + id;
                    }
                } else if (type == 3) {
                    this.goVideo(id);
                }
            },
            goLive(id){
                if (getUrlParam('mwb')) {
                    location.href = configData.jumpUrl + '/live.html?id=' + id + '&mwb=' + 'mobi';
                } else {
                    location.href = configData.jumpUrl + '/live.html?id=' + id;
                }
            },

            goVideo(id) {
                if(getUrlParam('mwb')){
                    location.href = configData.jumpUrl + '/video.html?id=' + id + '&mwb=' + 'mobi';
                }else {
                    location.href = configData.jumpUrl + '/video.html?id=' + id;
                }
            },
            goThematic(id) {
                if(getUrlParam('mwb')){
                    location.href = configData.jumpUrl + '/thematic.html?id=' + id + '&mwb=' + 'mobi';
                }else {
                    location.href = configData.jumpUrl + '/thematic.html?id=' + id;
                }
            },
            goAdv(url) {
                window.location.href = url;
            },
            goHotSearch(){
                if(getUrlParam('mwb')){
                    location.href = configData.jumpUrl + '/hotSearch.html?mwb=' + 'mobi';
                }else {
                    location.href = configData.jumpUrl + '/hotSearch.html';
                }
            },
            down() {
                var u = navigator.userAgent;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.com.qlwb.qiluyidian'
                } else if (isiOS) {
                    window.location.href = 'https://itunes.apple.com/cn/app/qi-lu-yi-dian-ti-yu-gong-jiao/id903816468?mt=8'
                }
            },
            goHome() {
                if(getUrlParam('mwb')){
                    location.href = configData.jumpUrl + '/mobiIndex.html';
                }else {
                    location.href = configData.jumpUrl + '/index.html';
                }
            },
            toTop(){
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            },
            addColor() {
                if (this.comment.length > 0) {
                    this.$refs.send.style.color = '#E51C23'
                } else {
                    this.$refs.send.style.color = '#ea8a8b'
                }
            },
            hideInput() {
                this.comment = '';
                this.commentId = '';
                this.newsId = '';
                this.inputStatus = true;
            },
        },
        filters: {
            emojiFilter: function (text) {
                for (let i = 0; i < emojiJson.length; i++) {
                    for (let j = 0; j < emojiJson[i].length; j++) {
                        if (text.indexOf(emojiJson[i][j].Tag) != -1) {
                            text = text.replace(emojiJson[i][j].Tag, emojiJson[i][j].File);
                        }
                    }
                }
                return text;
            }
        },
    }
</script>

<style lang="scss" scoped>
  @import "../../common/css/base.scss";
  @import "css/atlas";
</style>



// WEBPACK FOOTER //
// App.vue?3e7cab9c